import * as React from "react"
const SvgGlobe = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 22.286a9.7 9.7 0 0 1-3.9-.788 10.1 10.1 0 0 1-3.175-2.137q-1.35-1.35-2.137-3.175a9.7 9.7 0 0 1-.788-3.9q0-2.076.788-3.9A10.1 10.1 0 0 1 4.925 5.21Q6.275 3.86 8.1 3.072a9.7 9.7 0 0 1 3.9-.787 9.7 9.7 0 0 1 3.9.787 10.1 10.1 0 0 1 3.175 2.138q1.35 1.35 2.137 3.175a9.7 9.7 0 0 1 .788 3.9 9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.137a9.7 9.7 0 0 1-3.9.788Zm-1-2.05v-1.95q-.825 0-1.412-.588A1.93 1.93 0 0 1 9 16.286v-1l-4.8-4.8q-.075.45-.138.9-.062.45-.062.9 0 3.024 1.987 5.3Q7.975 19.86 11 20.236m6.9-2.55q.5-.55.9-1.188t.662-1.325q.263-.687.4-1.412.138-.725.138-1.475a7.85 7.85 0 0 0-1.363-4.475A7.7 7.7 0 0 0 15 4.886v.4q0 .825-.588 1.412A1.93 1.93 0 0 1 13 7.286h-2v2a.97.97 0 0 1-.287.712.97.97 0 0 1-.713.288H8v2h6q.424 0 .713.287.287.288.287.713v3h1q.65 0 1.175.387.525.388.725 1.013" />
  </svg>
)
export default SvgGlobe
